const state = {
   isNotification: false,
   notification: null,
}
const getters = {
   isNotification: (state) => state.isNotification,
   notification: (state) => state.notificationText,
}
const mutations = {
   isNotification(state, payload) {
      state.isNotification = payload
   },
   notification(state, payload) {
      state.notificationText = payload
   },
}
const actions = {
   setIsNotification({ commit, state }, isNotification) {
      commit('isNotification', isNotification)
   },
   setNotification({ commit, state }, notification) {
      commit('notification', notification)
   },
}

export default {
   actions,
   state,
   getters,
   mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/payers.js